const replaceWithBr = function(str) {
    return str.replace(/\n/g, "<br />")
}

export {
    replaceWithBr
}